import { cliente } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

/**
 * Lista de plantas activas. Las plantas casi nunca cambian, así que el
 * staleTime es agresivo (5 minutos) para evitar refetches innecesarios.
 */
export function usePlantas() {
  return useQuery({
    queryKey: ['plantas'],
    queryFn: () => cliente.plantas.listar(),
    staleTime: 5 * 60_000,
  });
}
